import type React from 'react';
import { mergeClasses, Tooltip } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { IncidentSeverity, IncidentState, SlaType } from 'types';
import { useSlaCalculation, useTick } from 'hooks';
import { useSlaCountdownStyles } from './SlaCountdown.styles';

interface SlaCountdownProps {
  slaDeadline: string;
  severity: IncidentSeverity;
  incidentState?: IncidentState;
  slaType?: SlaType;
  size?: 'medium' | 'large';
}

export const SlaCountdown: React.FC<SlaCountdownProps> = ({
  slaDeadline,
  severity,
  incidentState,
  slaType = SlaType.Ack,
  size = 'medium',
}) => {
  const styles = useSlaCountdownStyles();
  const { t } = useTranslation();
  const now = useTick(1000);
  const sla = useSlaCalculation(slaDeadline, severity, now);

  if (incidentState === IncidentState.Closed) return null;
  if (!sla) return null;

  const tooltipKey = `statusPanel.sla.${sla.status}`;
  const slaTypeLabel = slaType === SlaType.Update
    ? t('statusPanel.slaType.update')
    : t('statusPanel.slaType.ack');
  const sizeClass = size === 'large' ? styles.large : undefined;

  return (
    <Tooltip content={t(tooltipKey)} relationship="description">
      <span className={mergeClasses(styles.root, styles[sla.status], sizeClass)}>
        {sla.remainingFormatted} - {slaTypeLabel}
      </span>
    </Tooltip>
  );
};
